import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { TimeframeAPI as BaseAPI } from '@adornis/bh-timeframes/api/TimeframeAPI.js';
import { Timeframe } from '@adornis/bh-timeframes/entities/Timeframe.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { resolveFindTimeframesForCleanup } from '../server/resolveFindTimeframesForCleanup.js';
import { resolveUserAndMatchesCleanup } from '../server/resolveUserAndMatchesCleanup.js';
import { resolveUsersByTimeframeID } from '../server/resolveUsersByInstitutionIDAndTimeframeID.js';

const registerUsersByTimeframeID = registerQuery({
  operationName: 'resolveUsersByTimeframeID',
  resolve: resolveUsersByTimeframeID,
  type: () => [AdornisUser],
  params: [{ name: 'timeframeID', type: () => ID }],
});

export const registerUserAndMatchesCleanup = registerMutation({
  operationName: 'registerUserAndMatchesCleanup',
  resolve: resolveUserAndMatchesCleanup,
  type: () => [String],
  params: [{ name: 'timeframe', type: () => Timeframe }],
});

const registerFindTimeframesForCleanup = registerQuery({
  operationName: 'resolveFindTimeframesForCleanup',
  resolve: resolveFindTimeframesForCleanup,
  type: () => [String],
  params: [],
});

export namespace MatchingTimeframeAPI {
  export const TimeframeAPI = BaseAPI;
  export const usersByTimeframeID = registerUsersByTimeframeID;
  export const findForCleanup = registerFindTimeframesForCleanup;
  export const cleanupUsersAndMatches = registerUserAndMatchesCleanup;
}
